import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import {
  preventGroupToggleOnGroupHeaderBtn,
  preventMultiselectOnCtrlKeyClick,
  preventRowDeselectOnSameSelectedRowClick,
  removeArchivedRecords
} from "../../../other/utils/utils";
import SwivuStateMixin from "../mixins/SwivuStateMixin.jsx";
import { SwivuPreferenceStyleGrid } from "./SwivuPreferenceStyleGrid.jsx";

export class SwivuGrid extends SwivuStateMixin(SwivuPreferenceStyleGrid) {

  static get $name() {
    return "SwivuGrid";
  }

  static get type() {
    return WIDGET_KEYS.swivuGrid;
  }

  construct() {
    super.construct(...arguments);
    this.keyMap["Delete"] = { handler: "onPressDeleteKey" }
    this.on("cellMouseDown", preventMultiselectOnCtrlKeyClick);
    this.on("beforeSelectionChange", preventRowDeselectOnSameSelectedRowClick);
    // in bryntum 5.6.10 opening context menu by clicking the group header three dot button, the menu opens at the top left corner of the screen
    // and also the group get collapse/expand (when upgrading to bryntum 6.0 please verify by removing the following code)
    this.on("beforeToggleGroup", preventGroupToggleOnGroupHeaderBtn);
    this.on("cellClick", this.onSwivuCellClick.bind(this));
  }

  swivuIdChange(e) {
    /* for all grids that extends or use this SwivuGrid wrapper, will by default inherit this functionality where adding new record to grid will automatically start editing the
       first column of that row regardless of whatever filter/sort is applied on grid since we've a reference to currently added item in the grid
       disabling this feature for react component (or for main grids since they'll be edited from their relevant editors)
     */
    if (!this.reactComponent || this.reactComponent.props.swivDefaultEdit) {
      // there can be multiple same chain stores attached to the same grid,
      // hence the following code will run for each instance of chain store,
      // however the grid instance ref for the previous store will not be the same
      // checking isVisible state of grid before putting the row in editable state
      if (this.isVisible) {
        // we need to select record before putting the row in editable state
        this.selectedRecord = e.record;
        const editableField = this.parent?.getEditableField?.();
        const cellContext = {
          field: editableField ? editableField: editableField !== false ? this.columns.first.field: undefined,
          id: e.record.id,
          fitTargetContent: true
        };
        if (cellContext.field) {
          const cellContextEl = this.getCell(cellContext);
          // we could have simply started to edit the relevant cell but since store gets chained every time the grid opens; adding record to grid try to edit the row in dom which doesn't exist
          // so here we are trying to get a cell element about to edit from grid and checking if this is exists in DOM
          if (cellContextEl && ((typeof cellContextEl === "object" && document.body.contains(cellContextEl)) || this.swivuIsShadowNode(cellContextEl))) {
            // don't know why grid doesn't start cell editing immediately after record added to grid, setTimeout is a hack
            setTimeout(() => this.startEditing(cellContext));
          } else {
            console.log("Failed to edit record", { cellContextEl, e, cellContext, grid: this });
          }
        }
      }
    }
  }

  //If record is created from nested grid
  swivuIsShadowNode(el) {
    const rootElement =  el.getRootNode();
    return rootElement instanceof ShadowRoot && rootElement.contains(el);
  }

  // Todo: remove only the group event after update, leave idChange event
  // Todo: added patch in (version 5.1.3), remove this function after updating bryntum library to the next version
  // overriding this to incorporate grid group state to trigger state save event
  // seems like that bryntum mistakenly missing this functionality since the documentation have it mentioned https://bryntum.com/docs/scheduler-pro/api/Grid/view/mixin/GridState
  updateStore(store, was) {
    this.detachListeners('stateStoreGroupListener');
    store?.on({
      name    : 'stateStoreGroupListener',
      group   : 'triggerUpdate',
      idChange: 'swivuIdChange',
      thisObj : this
    });

    super.updateStore?.(store, was);
  }

  onPressDeleteKey() {
    removeArchivedRecords(this.store, this.selectedRecords)
  }

  onSwivuCellClick(e) {
    if (e.record?.isGroupHeader) return;
    const { column } = e;
    column.onSwivuColumnClick?.(e);
  }
}

SwivuGrid.initClass();
